import apiFetch from 'utils/apiFetch';

export const getUserData = (userId) => {
  const endPoint = `users/${userId}`;

  return apiFetch('GET', { endPoint });
};

export const getUserInvitationData = (hash) => {
  const endPoint = `users/invitations/${hash}`;

  return apiFetch('GET', { endPoint });
};

export const connectToUser = (userId) => {
  const params = {
    action: 'connect',
    userId,
  };

  const endPoint = 'users/connection';

  return apiFetch('POST', { endPoint }, params);
};

export const sendFeedbackSuggestionConnect = (userId, accept, fromType, fromId) => {
  const params = {
    element_type: 'user',
    element_id: userId,
    from_type: fromType,
    fromId,
    accept,
  };

  const endPoint = 'feedback';

  return apiFetch('POST', { endPoint }, params);
};

export const getRecommendedUsers = (includeInfo = 0, search = '') => {
  return apiFetch('GET', { endPoint: 'recommendations/users' }, { include_info: includeInfo, search });
};



// WEBPACK FOOTER //
// ./src/modules/users/actions.js